import ApiService from "@/common/api.service";

const PATH = "stock/quality-holds";

export const GET_STOCK_QUALITY_HOLDS = "getStockQualityHolds";
export const CREATE_STOCK_QUALITY_HOLD = "createStockQualityHold";
export const RELEASE_STOCK_QUALITY_HOLD = "releaseStockQualityHold";

const actions = {
  [GET_STOCK_QUALITY_HOLDS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_QUALITY_HOLD](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, payload)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [RELEASE_STOCK_QUALITY_HOLD](context, { id, ...payload }) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/release`, payload)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },
};

export default {
  actions,
};
